import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import Toast from 'light-toast';
import bg from "../assets/partner-deal-red.jpg";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

import {UserService} from "../services/user-service";

import {ResetPasswordPage, Container, LoginContent, LoginForm, Button, Link } from "../styles";
import { Card, InputGroup, FormControl } from 'react-bootstrap';
import { FaPhoneAlt } from "react-icons/fa";

function ResetPassword() {
    const [loading, setLoading] = useState(false);
    const [phone, setPhone] = useState('');

    const history = useHistory();

    function resetClick(event) {
      event.preventDefault();
      setLoading(true);
      UserService.reset_password(phone).then((result)=> {
        setLoading(false);
        if(result.valid) {
          history.push({pathname: '/', data: result.message});
        } else {
          Toast.fail(result.error, 3000);
        }
      }, (err)=> {
        // Toast.fail('Ocorreu um erro.', 3000);
        setLoading(false);
      });
    }
    
    function goBack() {
        history.push("/")
    }

    return (
      <ResetPasswordPage style={{backgroundImage: `url(${bg})`}}>
        <Container>
          <div className="empty" style={{height:0}}></div> 
          <LoginContent>
            <Card className="card">
              <Card.Body className="card-body">
                <LoginForm onSubmit={(event)=> resetClick(event)}>
                  <h1>Recuperar palavra-passe</h1>
                  <p>Insira o seu numero de Telemóvel clique no botão <b>Continuar</b></p>

                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text><FaPhoneAlt /></InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      placeholder="Insira número de telefone"
                      type="number" 
                      value={phone}
                      onChange={(e)=> setPhone(e.target.value)}
                    />
                  </InputGroup>
                  
                  
                  {loading ?
                  <Loader
                      type="ThreeDots"
                      color="#BF2F38"
                      height={50}
                      width={50}
                  /> :
                  <Button disabled={!phone ? true : false}>Continuar</Button>}
                  <Link onClick={()=> goBack()}>Voltar</Link>
                </LoginForm>
              </Card.Body>
            </Card> 
          </LoginContent>
        </Container>
      </ResetPasswordPage>
    );
}

export default ResetPassword;
